export const ACCOUNT_DOWNLOAD_TASK_NAME = 'account-download';
export const ACCOUNT_DOWNLOAD_FILE_NAME = 'Account-info-report';

export const ACCOUNT_DOWNLOAD_FILE_HEADERS = {
    id: 'ID',
    name: 'Name',
    type: 'Type Description',
    status: 'Status code',
    entityType: 'Entity Type Code',
    templateUserId: 'Template User ID',
    notes: 'Notes',
    reportsNotes: 'Notes Reports',
    administrator: 'Administrator',
    newsletterAccount: 'Free Newsletter Account',
    projectCodeEnabled: 'Project Codes Enabled',
    projectCodeRequired: 'Project Codes Required',
    liveChatEnabled: 'Live Chat Enabled',
    allowedIpRanges: 'Allowed IP Ranges',
    maxResultPageSize: 'Max Result Page Size',
    templateAccount: 'Template',
    accreditationStatus: 'Accreditation Status Description',
    accreditationDisabled: 'Accreditation Disabled',
    country: 'Country Description',
    localId: 'Local ID',
    maxAlertsPerEmail: 'Max Alerts Per Email',
    untracked: 'Untracked',
    sfCommunitiesEnabled: 'SFDC Communities Enabled',
    screenRecordingEnabled: 'Screen Recording Enabled',
    parentAccountId: 'Parent Account ID',
    deleted: 'Deleted',
    licenseEnabled: 'Licensed Enabled Users',
    crmOnlyEnabled: 'CRM Enabled Users',
    mobileOnlyEnabled: 'Mobile Enabled Users',
    newsletters: 'Newsletters Users',
    noAccess: 'No Access',
    virtual: 'Conference Users',
};
